module.exports = __webpack_public_path__ + "media/stem/sc-right-b7a20fc0.svg";